module.exports = __webpack_public_path__ + "static/media/tiles-viewPlantsDetails.af084827.svg";